import { createModule } from '../../createModule';
export const createSmartradeAPI = createModule(({ http }) => {
    return {
        getIsins: async () => {
            const res = await http.get('/v2/smartrade/isins');
            return res;
        },
        getTrades: async (params) => {
            const res = await http.get('/v2/smartrade/trades', {
                params,
            });
            return res;
        },
        getSecurityEntries: async () => {
            const res = await http.get('/v2/smartrade/security-entries');
            return res;
        },
        getMySQLSecurityEntries: async () => {
            const res = await http.get('/v2/smartrade/mysql/security-entries');
            return res;
        },
        resendOrder: async (body) => {
            const res = await http.post('/v2/smartrade/resend-order', { body: body });
            return res;
        },
        resendConfirmationEmail: async (body) => {
            const res = await http.post('/v2/smartrade/resend-confirmation-email', { body: body });
            return res;
        },
        resendNotificationEmail: async (body) => {
            const res = await http.post('/v2/smartrade/resend-notification-email', { body: body });
            return res;
        },
        updateSecurityEntry: async (body) => {
            const res = await http.patch('/v2/smartrade/security-entry', { body: body });
            return res;
        },
        addSecurityEntry: async (body) => {
            const res = await http.post('/v2/smartrade/security-entry', { body: body });
            return res;
        },
        getClients: async () => {
            const res = await http.get('/v2/smartrade/clients');
            return res;
        },
        updateClientEmailDist: async (params) => {
            const firmid = params.data.firmid;
            if (!firmid) {
                return Promise.reject(new Error('Missing firmid'));
            }
            const res = await http.patch(`/v2/smartrade/client/${firmid}`, {
                body: {
                    ...params,
                },
            });
            return res;
        },
    };
});
